import React, { Fragment, useState } from "react";
import { useForm } from "react-hook-form";

const ProjectForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (data) => {
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    // Add static parameter to data
    data.website = "marketing";

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URI}/contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        setSuccessMessage("Your message has been sent successfully!");
        reset();
      } else {
        throw new Error("Something went wrong, please try again.");
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row mb-n4">
          <div className="col-md-12 col-12 mb-4">
            <input
              type="text"
              placeholder="Your Name *"
              name="name"
              {...register("name", {
                required: "Name is required",
              })}
              className="w-full p-2 border border-solid border-gray-500 rounded-md focus:outline-none focus:border-blue-500"
            />
            {errors?.name && <p>{errors.name?.message}</p>}
          </div>
          <div className="col-md-12 col-12 mb-4">
            <input
              type="email"
              placeholder="Email *"
              name="email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Invalid email address",
                },
              })}
              className="w-full p-2 border border-solid border-gray-500 rounded-md focus:outline-none focus:border-blue-500"
            />
            {errors?.email && <p>{errors.email?.message}</p>}
          </div>
          <div className="col-12 mb-6">
            <textarea
              name="message"
              placeholder="Message"
              {...register("message", {
                required: "Message is required",
              })}
              className="w-full p-2 border border-solid border-gray-500 rounded-md focus:outline-none focus:border-blue-500"
            ></textarea>
            {errors?.message && <p>{errors.message?.message}</p>}
          </div>
          <div className="col-12 text-center mb-4">
            <button
              type="submit"
              className="btn btn-primary btn-hover-secondary"
              disabled={loading}
            >
              {loading ? "Sending..." : "Get a free consultation"}
            </button>
          </div>
        </div>
      </form>
      {successMessage && (
        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          {successMessage}
        </p>
      )}
      {errorMessage && (
        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          {errorMessage}
        </p>
      )}
    </Fragment>
  );
};

export default ProjectForm;
